/* eslint-disable no-unused-vars */
import { Button, Icon } from "@mui/material";
import pxToRem from "assets/theme/functions/pxToRem";
import MDTypography from "components/MDTypography";
import React from "react";

function basicButton({
  title = "",
  icon,
  background,
  color,
  action,
  disabled = false,
  border = false,
  borderColor = "var(--gray-300, #D0D5DD)",
  ml = pxToRem(16),
}) {
  return (
    <Button
      disableRipple
      disabled={disabled}
      sx={{
        marginLeft: ml,
        backgroundColor: background,
        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)", // ✅ Added shadow
        borderRadius: pxToRem(0),
        "&:hover": {
          backgroundColor: background,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)", // Optional hover shadow
          border: "none",
        },
        height: pxToRem(40),
        paddingX: pxToRem(16),
        border: border ? `1px solid ${borderColor}` : "none",
      }}
      onClick={() => action()}
    >
      <Icon fontSize={pxToRem(14)} sx={{ color }}>
        {icon}
      </Icon>
      {title && (
        <MDTypography
          fontSize={pxToRem(14)}
          sx={{ color, marginLeft: pxToRem(8.6), lineHeight: pxToRem(20) }}
        >
          {title}
        </MDTypography>
      )}
    </Button>
  );
}

export default basicButton;
